import * as React from "react";
import HrefLang from "@shared/head/HrefLang";
import { graphql } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "@app/Layout.tsx";
import PostCard from "@/widgets/PostCard";
import Pagination from "@shared/ui/Pagination";

// SEO Meta
export const Head = (props) => {
  function categoryTitle() {
    let blogName = !!+process.env.GATSBY_DASHLY ? ` — Dashly Blog tag` : ` — блог Carrot quest`;

    let pagesText = new String();
    if (props.pageContext.numPages > 1) {
      pagesText = !!+process.env.GATSBY_DASHLY ? `, page ` : `, стр. `;
      pagesText = pagesText + props.pageContext.currentPage;
    }

    return `${capitalizeFirstLetter(props.pageContext.title)}${pagesText}${blogName}`;
  }

  function categoryDescription() {
    let description = "";

    if (!!+process.env.GATSBY_DASHLY) {
      description = `Tag ${capitalizeFirstLetter(props.pageContext.title)} in Dashly blog`;

      if (props.pageContext.numPages > 1) {
        description += `, page ${props.pageContext.currentPage}`;
      }
    } else {
      let category = `Раздел`;
      let blog = `в блоге Carrot quest`;
      let pagesText = "";

      if (props.pageContext.numPages > 1) {
        pagesText = `, стр. ${props.pageContext.currentPage}`;
      }

      description = `${category} ${props.pageContext.title.toLowerCase()} ${blog}${pagesText}`;
    }

    return description;
  }

  const canonical = `https://www.${process.env.GATSBY_DOMAIN}${props.pageContext.pagePath}/`;

  return (
    <>
      <title>{categoryTitle()}</title>
      <meta name="description" content={categoryDescription()} />
      <link rel="canonical" href={canonical} />
      {!!+process.env.GATSBY_DASHLY && <HrefLang url={canonical} />}
    </>
  );
};

export default class BlogCategory extends React.Component {
  constructor(props) {
    super(props);

    this.posts = this.props.data.allBlogPost.edges;
  }

  render() {
    return (
      <Layout className="page page-blog" landing={false}>
        <Container className="mt-5">
          <h1 dangerouslySetInnerHTML={{ __html: capitalizeFirstLetter(this.props.pageContext.title) }} />
          <Row>
            {this.posts.map((post) => (
              <Col md={6} lg={4} className="mt-4 mb-3" key={post.node.wp_id}>
                <PostCard node={post.node} />
              </Col>
            ))}
          </Row>
          <Pagination
            pages={this.props.pageContext.numPages}
            current={this.props.pageContext.currentPage}
            path={this.props.pageContext.pagePath}
          />
        </Container>
      </Layout>
    );
  }
}

export const tagPage = graphql`
  query ($id: Int!, $skip: Int!, $limit: Int!) {
    allBlogPost(
      filter: { tags: { in: [$id] }, lang: { nin: ["es", "br"] } }
      sort: { date: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          wp_id
          title
          slug
          parentPage {
            slug
          }
          featured_media_medium_url
          featured_media_size
        }
      }
    }
  }
`;

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
